export default defineNuxtRouteMiddleware(async () => {
  const { isAuthenticated } = useCurrentUser();

  if (!isAuthenticated.value) {
    await useDatabaseClient().auth.getClaims();
  }
});
